import { ContactStateModel } from './contact.state'

export enum CONTACT_ACTIONS {
	NEW = '[Contact] New',
	LOAD = '[Contact] Load',
	UPDATE = '[Contact] Update',
	GET_ZIP = '[Contact] Get Zip',
}

export namespace ContactAction {
	export class New {
		static readonly type = CONTACT_ACTIONS.NEW
	}

	export class Load {
		static readonly type = CONTACT_ACTIONS.LOAD
		constructor(public payload: ContactStateModel) {}
	}

	export class Update {
		static readonly type = CONTACT_ACTIONS.UPDATE
		constructor(public payload: Partial<ContactStateModel>) {}
	}

	export class GetZip {
		static readonly type = CONTACT_ACTIONS.GET_ZIP
		constructor(public payload: string) {}
	}
}
